import type { AppUserInfo } from "@/shared/model/user/AppUserInfo";
import type { PageAccessChecker } from "@/shared/model/user/permissions/AccessCheckersApi";

export abstract class Page {
  constructor(
    readonly key: string,
    readonly checker: PageAccessChecker,
    readonly children: Page[] = [],
  ) {}

  userCanAccess(user: AppUserInfo): boolean {
    return this.checker.check(user);
  }

  addChildPage(childPage: Page): void {
    this.children.push(childPage);
    this.checker.addChild(childPage.checker);
  }

  abstract buildUrl(customParams?: Record<string, string>): string;
  abstract isReact(): boolean;
}

export class ReactPage extends Page {
  constructor(
    readonly key: string,
    readonly route: string,
    readonly checker: PageAccessChecker,
  ) {
    super(key, checker);
  }

  buildUrl(): string {
    return this.route;
  }

  isReact(): boolean {
    return true;
  }
}

export class DojoPage extends Page {
  constructor(
    readonly key: string,
    readonly plugin: string,
    readonly cType: string,
    readonly task: string,
    readonly checker: PageAccessChecker,
    readonly queryParams?: string,
  ) {
    super(key, checker);
  }

  buildUrl(customParams?: Record<string, string>): string {
    const pageParams = this.queryParams ?? "";
    const moreParams = new URLSearchParams(customParams).toString();
    const params = [pageParams, moreParams].filter((s) => s !== "").join("&");
    return `/content/${this.cType}/?task=${this.task}${params === "" ? "" : "&"}${params}`;
  }

  isReact(): boolean {
    return false;
  }
}
